import React from "react";
import { Toaster } from "react-hot-toast";

interface ToasterProps {

}

const LsToaster: React.FC<ToasterProps> = () => {
   return <Toaster position="bottom-center" containerStyle={{
      bottom: -8,
   }} />;
}

export default LsToaster;